import apiClient from './client'
import { ThorJavaMenuResponse, ThorJavaMenuItemResponse, ThorJavaMenuImportResponse } from '../types/api'

export const thorjavaMenuApi = {
  /**
   * Lista itens do menu ThorJava
   */
  list: async (params?: {
    ativo?: boolean
    nivel?: number
    cnmenupai?: number
  }): Promise<ThorJavaMenuResponse[]> => {
    const response = await apiClient.get<ThorJavaMenuResponse[]>('/thorjava/menu', { params })
    return response.data || []
  },

  /**
   * Obtém menu em estrutura hierárquica (árvore)
   */
  getArvore: async (params?: {
    ativo?: boolean
    incluir_separadores?: boolean
  }): Promise<ThorJavaMenuItemResponse[]> => {
    const response = await apiClient.get<ThorJavaMenuItemResponse[]>('/thorjava/menu/arvore', { params })
    return response.data || []
  },

  /**
   * Obtém um item específico do menu
   */
  get: async (itemId: number): Promise<ThorJavaMenuResponse> => {
    const response = await apiClient.get<ThorJavaMenuResponse>(`/thorjava/menu/${itemId}`)
    return response.data
  },

  /**
   * Importa menu do banco da empresa
   */
  importar: async (empresaId: number, substituirExistente: boolean = false): Promise<ThorJavaMenuImportResponse> => {
    const response = await apiClient.post<ThorJavaMenuImportResponse>('/thorjava/menu/importar', {
      empresa_id: empresaId,
      substituir_existente: substituirExistente,
    })
    return response.data
  },
}

